import { v4 } from "uuid";
import { iChatData } from "../types";

export function appendErrorMessageTochat(chatData: iChatData[], setChatData: any, errorMessage: string) {
  setChatData((prev: iChatData[]) => {
    if (prev.length > chatData.length) {
      return [
        ...prev.slice(0, prev.length - 1),
        {
          isErrorMessage: true,
          id: v4(),
          message: errorMessage,
          prompt: [],
          isUserMessage: false,
          isLoading: false,
          destinationList: [],
          singleSelectedDestination: false,
          isCompleteMessage: true,
        },
      ];
    }
    return [
      ...prev,
      {
        isErrorMessage: true,
        id: v4(),
        message: errorMessage,
        prompt: [],
        isUserMessage: false,
        isLoading: false,
        destinationList: [],
        singleSelectedDestination: false,
        isCompleteMessage: true,
      },
    ];
  });
}
